import React, { Component } from 'react';
import { AppConstants } from '../../core/constants';
import service from '../../core/service';
import * as yup from 'yup';
import { toast } from 'react-toastify';
interface IProps {
}
interface IState {
  openSendTicketModal: boolean;
  openActionModal: boolean;
  loading: boolean;
  leadsList?: any;
  page: number;
  count: number;
  subject: string;
  selectedLead:any;
  membersList:any;
  member:any;
  errorsList:any;
  ticketCount: string;
  isSendingTicket: boolean;
  rowsCountList:any;

}

export class LeadsController extends Component<IProps, IState> {

  datePickerRef: any;

  constructor(props: any) {
    super(props);
    this.datePickerRef = React.createRef();
  }

  state: IState = {
    openSendTicketModal: false,
    openActionModal: false,
    loading: false,
    leadsList: [],
    page: 1,
    membersList:[],
    ticketCount:"",
    isSendingTicket: false,
    errorsList:[],
    selectedLead:{},
    subject: "",
    count: 6,
    member:null,
    rowsCountList:[6, 10, 50, 100],

  };
  handleChangeMember = (e: any) => {
    this.setState({ member: e.target.value })
  };
  emptyCount= () => {
    this.setState({ count: 6, page:1 });
  };
  getLeadsList = async () => {
    this.setState({ loading: true })
    const { page, count } = this.state;
    let parameters = {
      page: page ? page.toString() : "1",
      count: count ? count.toString() : "6",
    }
    let url = new URL(`${AppConstants.base_url_api}leads`)
    for (const [key, value] of Object.entries(parameters)) {
      if (value) {
        url.searchParams.append(key, value)
      }
    }
    try {
      const response = await service.Leads.list(url.search);
      if (response) {
        this.setState({ leadsList: response?.data?.data, openSendTicketModal: false, loading: false })
      } else {
        this.setState({ loading: false })
      }
    } catch (error) {
    }
  };
  paginationRowTimeOut: string | number | NodeJS.Timeout | undefined;
  handleCount = (value: any) => {
    this.setState({ count: value, page:1 });
    clearTimeout(this.paginationRowTimeOut);
    this.paginationRowTimeOut = setTimeout(() => {
      this.getLeadsList()
    }, 800);
  }
  paginationTimeOut: string | number | NodeJS.Timeout | undefined;
  handleChangePage = (event: React.ChangeEvent<unknown>, value: number) => {
    this.setState({ page: value })
    clearTimeout(this.paginationTimeOut);
    this.paginationTimeOut = setTimeout(() => {
      this.getLeadsList()
    }, 800);
  }
  handleSendTicketModal = (item:any) =>{
    if(item?.free_lead_total === 0){
        toast.error("سرنخ‌ باقی‌مانده‌ای وجود ندارد")
    }
    else {
        this.setState({openSendTicketModal: true, selectedLead: item });
        this.getMembersList();
    }
  }
  getMembersList = async () => {
    try {
      const response = await service.LeadsMember.list();
      if (response) {
        this.setState({ membersList: response?.data?.data?.list, loading: false })
      } else {
        this.setState({ loading: false })
      }
    } catch (error) {
    }
  };
 async handleSendLeadTicket () {
    const { ticketCount, member, selectedLead } = this.state;
    this.setState({ isSendingTicket: true });
    const schema = yup.object({
        ticketCount: yup.number().typeError('تعداد تیکت الزامی می‌باشد').required("تعداد تیکت الزامی می‌باشد").positive("تعداد تیکت نمی‌تواند کوچک‌تر از صفر باشد").min(1, 'تعداد تیکت حداقل باید ۱ باشد')
        .max(selectedLead?.free_lead_total, 'تعداد تیکت نمی تواند بیشتر از تعداد آزاد باشد'),
        member: yup.string().required("انتخاب عضو اجباری می‌باشد"),
        });   
        try {
          await schema.validate({ ticketCount, member}, { abortEarly: false });
          const response = await service.Leads.ticket( selectedLead?.id, parseInt(ticketCount) , member);
            if (response) {
              if(response?.status === 200){

                this.setState({ errorsList:[], openSendTicketModal: false, selectedLead:{}, member:null, ticketCount:"" });
                this.getLeadsList();
                toast.success("با موفقیت ارسال شد");
              }
              else{
                toast.error("مشکلی پیش آمده‌است");
              }
            } else {
                this.setState({ loading: false });
            }  
        } catch (err: any) {
          this.setState({ errorsList: err.inner  })
        }
        finally {
          this.setState({ isSendingTicket: false });
        }
  }
}
export default LeadsController;